// Observe the existing card, whose text gives it a stable box before the image loads.
// Native lazy hints alone still eagerly load this transformed legacy image list in WebKit.
const states = new WeakMap();
export const deferredImage = {
  inserted(el, binding) {
    const state = { source: binding.value, visible: false, observer: null };
    const reveal = () => {
      if (states.get(el) !== state) return;
      state.visible = true;
      if (state.source) el.setAttribute('src', state.source);
      if (state.observer) state.observer.disconnect();
    };
    states.set(el, state);
    if (typeof IntersectionObserver === 'undefined') { reveal(); return; }
    state.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) reveal();
    }, { rootMargin: '300px 0px' });
    state.observer.observe(el.closest('.menu__dish-card, .k-menu__dish-card, .k-ingredient-card') || el);
  },
  update(el, binding) {
    const state = states.get(el);
    if (!state || state.source === binding.value) return;
    state.source = binding.value;
    if (state.visible) {
      if (state.source) el.setAttribute('src', state.source);
      else el.removeAttribute('src');
    }
  },
  unbind(el) {
    const state = states.get(el);
    if (state && state.observer) state.observer.disconnect();
    states.delete(el);
  },
};
